import { type SchemaDigitalOrder } from '../../openApi';
import { DigitalOrderStatuses } from './DigitalOrderStatuses';

export const DEFAULT_DIGITAL_ORDER: SchemaDigitalOrder = {
    id: '',
    items: [],
    order_number: '0',
    status: DigitalOrderStatuses.NEW,
    total_final_price: '0.00',
    total_price: '0.00',
    holder_email: '',
    send_date: '',
    client: {
        last_name: '',
        first_name: '',
        phone: '',
        email: '',
        agreement_personal_data: true,
        is_notify: false,
        need_ozon_registration: false,
        need_phone_verification: false,
    },
    acquiring_id: '',
    created_at: '1970-01-01T00:00:00.000Z',
};
